import DataTable, { DataTableColumn } from "components/common/DataTable";
import { capitalize } from "lodash";
import moment from "moment-timezone";
import { EventJournal } from "types/Event";
import { dateTimeFormatter } from "utils/dateTimeFormatter";

interface HistoryTableProps {
    journals: EventJournal[];
}

const getLocalTimestamp = (timestamp: string | Date) =>
    moment.utc(timestamp).local();

const capitalizeTokens = (value: string) =>
    value
        .split(",")
        .map((token) => capitalize(token.trim()))
        .filter((token) => token.length > 0)
        .join(", ");

const columns: DataTableColumn<EventJournal>[] = [
    {
        label: "Date",
        key: "create_time",
        render: (n: EventJournal) => {
            const localTimestamp = getLocalTimestamp(n.create_time);
            return dateTimeFormatter.date(localTimestamp) ?? "-";
        },
    },
    {
        label: "Time",
        key: "create_time_time",
        sortKey: "create_time",
        render: (n: EventJournal) => {
            const localTimestamp = getLocalTimestamp(n.create_time);
            return dateTimeFormatter.time(localTimestamp) ?? "-";
        },
    },
    {
        label: "Actions",
        key: "operation",
        render: (n: EventJournal) => (n.operation ? capitalizeTokens(n.operation) : "-"),
    },
    {
        label: "By User/Event",
        key: "user",
        render: (n: EventJournal) => {
            if (n.user) {
                return n.user.toLowerCase() === "event" ? "Event" : "User";
            }
            return "-";
        },
    },
    {
        label: "Command Status",
        key: "attributes.status",
        render: (n: EventJournal) =>
            n.attributes?.status ? capitalize(n.attributes.status) : "-",
    },
];

export const HistoryTable = (props: HistoryTableProps) => {
    return (
        <div>
            <DataTable columns={columns} data={props.journals} />
        </div>
    );
};
